/// <amd-module name="Search/Shared/Components/HighlightComponent/HighlightComponent.Props" />

export interface IHighlightComponentProps {
    text: string;

    pattern: string;

    className?: string;
}

